import React from 'react';

function SignInScreen() {
  return <div>Login</div>;
}

export default React.memo(SignInScreen);
